import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const PublicRoute = ({ children }) => {
  const [token, setToken] = useState(Cookies.get('AdminToken'));
  const [userInfo, setUserInfo] = useState(() => {
    try {
      const stored = Cookies.get('user-info');
      return stored ? JSON.parse(stored) : null;
    } catch (err) {
      console.error('Error parsing user-info cookie:', err);
      return null;
    }
  });

  useEffect(() => {
    const checkCookies = () => {
      setToken(Cookies.get('AdminToken'));
      try {
        const stored = Cookies.get('user-info');
        setUserInfo(stored ? JSON.parse(stored) : null);
      } catch {
        setUserInfo(null);
      }
    };

    checkCookies(); 
    const interval = setInterval(checkCookies, 2000);
    return () => clearInterval(interval);
  }, []);

  if (token && userInfo?.is_billing_added === true) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default PublicRoute;
